import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default WrappedComponent =>
    class HiddenFieldWrapper extends Component {
        static propTypes = {
            hidden: PropTypes.bool,
            input: PropTypes.object,
            onChange: PropTypes.func
        };

        componentDidUpdate(prev) {
            const { hidden, input, onChange } = this.props;

            if (!prev.hidden && hidden) {
                input.onChange(undefined);
                onChange && onChange(undefined);
            }
        }

        render() {
            const { hidden, ...props } = this.props;

            return !hidden && <WrappedComponent {...props} />;
        }
    }
